import { Link } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

const values = [
  { icon: 'ri-search-eye-line', title: '分类清晰', desc: '按榜单、类型与完结状态精心分类，让好作品不再被埋没，找漫画更快。' },
  { icon: 'ri-team-line', title: '聚合独家', desc: '与多家优质汉化组合作，聚合独家翻译与精校内容，出品稳定有保障。' },
  { icon: 'ri-heart-line', title: '尊重创作', desc: '坚持尊重每一位创作者与汉化组的劳动成果，提供规范的作品信息导航。' },
  { icon: 'ri-flashlight-line', title: '持续更新', desc: '热门榜与最新更新实时同步，让追番体验更丝滑、信息更及时。' },
];

const steps = [
  { no: '01', title: '聚合整理', desc: '收集整理排行榜、完结漫画与汉化组独家作品，建立清晰的分类索引。' },
  { no: '02', title: '精选推荐', desc: '依据阅读热度与读者反馈，动态生成热门推荐榜单，挖掘潜力好作品。' },
  { no: '03', title: '便捷导航', desc: '提供搜索、筛选与站内跳转，让每一位读者都能快速找到想追的作品。' },
  { no: '04', title: '陪伴成长', desc: '与同好一起追更、交流，让漫画陪伴每一天，一起见证好作品诞生。' },
];

export default function About() {
  useSeo({
    title: '关于动漫之家漫画网 - 品牌介绍与发展理念',
    description:
      '了解动漫之家漫画网的品牌介绍、网站定位、发展理念与内容原则，聚合排行榜热门推荐、完结漫画与汉化组独家分类，服务千万漫画爱好者。',
    canonicalPath: '/about',
  });

  return (
    <div>
      {/* Head */}
      <section className="border-b border-background-200 bg-gradient-to-br from-secondary-50 via-background-50 to-primary-50">
        <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <nav className="flex items-center gap-1.5 text-sm text-foreground-500" aria-label="面包屑">
            <Link to="/" className="transition-colors hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700">关于我们</span>
          </nav>
          <div className="mx-auto mt-6 max-w-2xl text-center">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-heart-3-line"></i> 关于我们
            </span>
            <h1 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">让每一部好漫画都被看见</h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              动漫之家漫画网是一站式漫画内容聚合平台，围绕排行榜热门推荐、完结漫画与汉化组独家分类构建内容生态，为千万漫画爱好者提供便捷、清晰、可信的作品导航。
            </p>
          </div>
        </div>
      </section>

      {/* Brand positioning */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div className="w-full">
            <h2 className="font-heading text-xl text-foreground-950 md:text-2xl">我们是谁</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              我们热爱漫画，也理解追番人找作品的痛点。动漫之家漫画网从“排行榜热门推荐”出发，逐步建立起涵盖完结漫画、汉化组独家内容在内的分类大全，让你不必在无数信息中大海捞针。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              这里既有实时人气榜单帮你发现当下热门，也有按热血、恋爱、玄幻、悬疑等类型整理的作品索引，无论你是新入坑还是老读者，都能各取所需。
            </p>
            <div className="mt-6 flex flex-wrap gap-4">
              <div className="flex items-center gap-2 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
                <span className="font-heading text-2xl text-primary-500">3000+</span>
                <span className="text-xs text-foreground-500">收录作品</span>
              </div>
              <div className="flex items-center gap-2 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
                <span className="font-heading text-2xl text-accent-600">36</span>
                <span className="text-xs text-foreground-500">热门分类</span>
              </div>
              <div className="flex items-center gap-2 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
                <span className="font-heading text-2xl text-secondary-600">120万+</span>
                <span className="text-xs text-foreground-500">月活读者</span>
              </div>
            </div>
          </div>
          <div className="w-full rounded-2xl border border-background-200 bg-background-100 p-8">
            <h3 className="font-heading text-lg text-foreground-950">内容原则</h3>
            <ul className="mt-5 space-y-4 text-sm text-foreground-700">
              {[
                ['尊重版权', '作品信息仅用于导航与介绍，坚持尊重创作者与汉化组的版权。'],
                ['真实可读', '坚持真实、准确、可读的内容，不做无意义的堆砌。'],
                ['分类清晰', '以榜单、类型、状态多重维度组织内容，让检索一目了然。'],
                ['动态更新', '热门榜与更新信息实时同步，紧跟作品动态。'],
              ].map(([t, d]) => (
                <li key={t} className="flex gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                  <div>
                    <p className="font-semibold text-foreground-900">{t}</p>
                    <p className="mt-0.5 text-foreground-600">{d}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
          <div className="text-center">
            <h2 className="font-heading text-xl text-foreground-950 md:text-2xl">我们的理念</h2>
            <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-500">用清晰的分类与靠谱的推荐，陪伴每一次追番。</p>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className={`${v.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Steps */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="text-center">
          <h2 className="font-heading text-xl text-foreground-950 md:text-2xl">我们的发展之路</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-500">从一份榜单出发，逐步构建起完整的漫画内容生态。</p>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s) => (
            <div key={s.no} className="relative rounded-lg border border-background-200 bg-background-100 p-6">
              <span className="font-heading text-3xl text-primary-200">{s.no}</span>
              <h3 className="mt-3 text-base font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Contact CTA */}
      <section className="mx-auto max-w-7xl px-4 pb-14 md:px-6">
        <div className="rounded-2xl bg-primary-900 px-6 py-12 text-center">
          <h2 className="font-heading text-2xl text-background-50">加入我们，一起追番</h2>
          <p className="mx-auto mt-3 max-w-lg text-sm text-primary-200">
            无论是投稿建议、汉化组合作还是内容反馈，欢迎随时与我们联系，共同建设更棒的漫画社区。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <a href="mailto:service@dmzj-comic.example.com" className="whitespace-nowrap rounded-lg bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600">
              <i className="ri-mail-line mr-1"></i> service@dmzj-comic.example.com
            </a>
            <Link to="/faq" className="whitespace-nowrap rounded-lg border border-primary-700 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-800">
              查看常见问题
            </Link>
          </div>
        </div>
      </section>

      {/* AboutPage JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于动漫之家漫画网',
            description: '动漫之家漫画网的品牌介绍、网站定位、发展理念与内容原则。',
            about: {
              '@type': 'Organization',
              name: '动漫之家漫画网',
              description: '一站式漫画内容聚合平台，聚合排行榜热门推荐、完结漫画与汉化组独家分类。',
            },
          }),
        }}
      />
    </div>
  );
}